export default __webpack_public_path__ + "static/hero_business_mob_img_5-78cbf8fd2f1fdfe835faac3c231f1eee.png";